
import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Button, Modal, Checkbox, Upload, Table, Image, Form, Tag, Popover, Select, notification } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, FileImageOutlined } from '@ant-design/icons';
import { fetchData, sendData } from '../../../httpRequests';
import { collection, query, where, onSnapshot, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebase';
import { useNavigate } from 'react-router-dom';
const { Search } = Input;
const { Option } = Select;

const form = {
    first_name: '',
    email: '',
    password: '',
    pharmacy_id: Number(localStorage.getItem("PHARMACY_LOGGED")),
    zip_code: 'admin',
    active: 0
}


export default function CreateDrivers() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState(form)
    const [modalCreateDriver, setModalCreateDriver] = useState(false)
    const [driver, setDriver] = useState([])
    const [driverFilter, setDriverFilter] = useState([])

    const { first_name, pharmacy_id, email, password, zip_code, active } = formValues
    useEffect(() => {
        getDrivers()
        driverActiver()
    }, [])

    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    }


    const getDrivers = () => {
        const url = '/user/getDriverByAdmin';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                setDriver(response.driver)
                setDriverFilter(response.driver)
                // console.log(response.driver)
            }
        })
    }

    const driverActiver = () => {
        const q = query(collection(db, 'driveActive'), where('pharmacy_id', '==', Number(localStorage.getItem('PHARMACY_LOGGED'))));
        onSnapshot(q, (querySnapshot) => {
            getDrivers();
            // console.log("Dios", querySnapshot.docChanges())
        })
    }

    const columns = [
        {
            title: 'Name',
            render: ({ id, first_name }) => (
                <div style={{ cursor: 'pointer' }} onClick={() => navigate('/driverDetails/' + id)}>
                    {first_name}
                </div>
            )
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'City',
            dataIndex: 'city',
            key: 'city',
        },
        {
            title: 'Address',
            dataIndex: 'address_1',
            key: 'address_1',
        },
        {
            title: 'Status',
            render: ({ active }) => (
                <div>
                    {
                        (active == true)
                            ? <div >


                                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                                    <div style={{ marginRight: '10px' }}>Online</div>
                                    <div className='online'></div>
                                </div>
                            </div>

                            : <div>

                                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                                    <div style={{ marginRight: '10px' }}>Offline</div>
                                    <div className='offline'></div>
                                </div>
                            </div>
                    }
                </div>
            )
        }
    ];
    const showModalCreaDriver = () => {
        setModalCreateDriver(true)
    }
    const handleCancel = () => {
        setModalCreateDriver(false)
    }
    const saveDriver = async () => {

        const url = '/user/createDriverUser';
        sendData(url, formValues).then(async (response) => {
            openNotificationWithIcon('success', 'Driver added successfully')
            getDrivers()
            handleCancel()
            // if (response.ok) {

            // if (seeImgInput != null && seeImgInput != undefined) {
            //     await handleFile(response.ads.id)
            // }
            // getAds()
            // openNotificationWithIcon('success', 'Ads added successfully')
            // setIsModalVisibleCreateAds(false)
            // } 
        })
    }

    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };

    const handleFilter = (e) => {
        let filtro = driverFilter.filter(element => {
            return element.active == e
        })
        if (e == 'null') {
            setDriver(driverFilter)
        } else {
            setDriver(filtro)
        }
    }

    const onSearch = (value) => {
        let text = value.target.value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        if (text) {
            const filter = driverFilter.filter((e) => {

                return e.first_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().includes(text)
            });

            setDriver(filter)
        } else {
            setDriver(driverFilter)
        }
    }

    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Col span={9}>
                    <Search
                        size='large'
                        placeholder='Search name'
                        onChange={onSearch}
                    />
                </Col>
                <Col span={9}>
                    <Select style={{ width: '100%' }} size='large' defaultValue="null" onChange={handleFilter}>
                        <Option value="null">All</Option>
                        <Option value={true}>
                            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                                <div style={{ marginRight: '10px' }}>Online</div>
                                <div className='online'></div>
                            </div>
                        </Option>
                        <Option value={false}>
                            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                                <div style={{ marginRight: '10px' }}>Offline</div>
                                <div className='offline'></div>
                            </div>
                        </Option>
                    </Select>

                </Col>
                <Col span={6}>
                    <Button
                        onClick={showModalCreaDriver}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        <PlusOutlined />
                        Create Driver
                    </Button>
                </Col>
            </Row>
            <Modal
                title="Create ads  Edit ads"
                visible={modalCreateDriver}
                onCancel={handleCancel}
                width={600}
                footer={null}
                closable={true}
            >
                <Row gutter={24}>

                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Name</label>
                        <Input
                            type='text'
                            size='large'
                            name="first_name"
                            value={first_name}
                            onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Email</label>
                        <Input
                            type='text'
                            size='large'
                            name="email"
                            value={email}
                            onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Password</label>
                        <Input
                            type='password'
                            size='large'
                            name="password"
                            value={password}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={24}>
                        <Button
                            onClick={saveDriver}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: '10px' }}
                        >
                            <SaveOutlined />
                            Save Driver
                        </Button>
                    </Col>
                    {/* <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Name</label>
                        <Input
                            type='text'
                            size='large'
                            name="name"


                        />
                    </Col> */}
                </Row>

            </Modal>
            <Table columns={columns} dataSource={driver} rowKey={(item) => item.id}
            />
        </div>
    )
}